import React from 'react';


import {IconLink} from '../../index';
import {buyConstants} from '../../../modules/Buy';
import {iconConstants} from '../../Icon';


function ContinueShoppingLink({}) {

    return (
        <IconLink
            iconType={iconConstants.ICON_ARROW_LEFT_2}
            labelI18n={'global.continue.shopping'}
            url={buyConstants.NAV_BUY_OVERVIEW_PAGE}
        />
    );
}


ContinueShoppingLink.propTypes = {};

ContinueShoppingLink.defaultProps = {};


export default ContinueShoppingLink;
